import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectGroup,
} from "@/components/ui/select"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import type { Course } from "@/modules/courses/entities/courses"

interface CoursesSelectorProps {
  courses: Course[]
  selectedCourse: Course | null
  setSelectedCourse: (course: Course | null) => void
}

export default function CoursesSelector({
  courses,
  selectedCourse,
  setSelectedCourse,
}: CoursesSelectorProps) {
  const handleValueChange = (id: string) => {
    setSelectedCourse(courses.find((course) => course.id === id) || null)
  }

  return (
    <Select value={selectedCourse?.id} onValueChange={handleValueChange}>
      <SelectTrigger className="relative h-10 w-fit flex-1 rounded-lg">
        <div className="flex items-center gap-2">
          <Avatar className="size-8">
            <AvatarFallback>{selectedCourse?.name.charAt(0)}</AvatarFallback>
          </Avatar>
          <SelectValue placeholder="Selecciona una materia">
            <span className="mr-2">{selectedCourse?.name}</span>
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {courses.map((course) => (
            <SelectItem key={course.id} value={course.id}>
              {course.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
